import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Modal, TextField, Button } from "@/shared/ui";
import { useLanguage } from "@/app";
import { normalizeEmail, validators } from "@/shared/lib/utils";
import styles from "./BillingEmailModal.module.scss";
/**
 * Просит email для чека, когда у пользователя не заполнен billing_email.
 * Сам не создаёт платёж — только собирает и сохраняет почту; продолжение
 * оплаты остаётся на вызывающей стороне (см. useBillingEmailGate).
 */
export const BillingEmailModal = ({ opened, onClose, onSubmit, defaultEmail, }) => {
    const { language } = useLanguage();
    const ru = language === "ru";
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const inputRef = useRef(null);
    useEffect(() => {
        if (opened) {
            setEmail(defaultEmail?.trim() || "");
            setBusy(false);
            setError(null);
        }
    }, [opened, defaultEmail]);
    // Общий валидатор проекта (shared/lib/utils): та же проверка, что и у поля
    // контакта в заявке на релиз, — двух разных «почт» в проекте быть не должно.
    // В отличие от прежней локальной регулярки он заякорен, поэтому адрес посреди
    // фразы («пишите на a@b.c») корректным больше не считается. Полноты RFC он
    // не даёт и не должен: задача — отсеять то, что до почтового сервера точно
    // не доедет.
    const emailValid = validators.email(email.trim());
    const handleSubmit = async () => {
        if (busy)
            return;
        if (!emailValid) {
            setError(ru ? "Введите корректный email" : "Enter a valid email");
            return;
        }
        setBusy(true);
        setError(null);
        try {
            // Тот же канон, что и у контакта в заявке: домен в нижний регистр,
            // локальная часть — как ввёл человек (см. normalizeEmail).
            await onSubmit(normalizeEmail(email));
        }
        catch {
            setError(ru
                ? "Не удалось сохранить email. Попробуйте ещё раз."
                : "Couldn't save the email. Please try again.");
            setBusy(false);
        }
    };
    return (_jsx(Modal, { opened: opened, onClose: busy ? () => { } : onClose, size: "sm", title: ru ? "Укажите email для чека" : "Email for the receipt", children: _jsxs("div", { className: styles.root, children: [_jsx("p", { className: styles.subtitle, children: ru
                        ? "На эту почту придёт чек об оплате. Без неё провести платёж не получится."
                        : "We'll send the payment receipt to this email. It's required to complete the payment." }), _jsx(TextField, { ref: inputRef, type: "email", inputMode: "email", autoComplete: "email", placeholder: "you@example.com", value: email, disabled: busy, onChange: (e) => {
                        setEmail(e.target.value);
                        if (error)
                            setError(null);
                    }, onKeyDown: (e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            void handleSubmit();
                        }
                    }, error: error || undefined }), _jsx(Button, { variant: "primary", size: "md", fullWidth: true, onClick: () => void handleSubmit(), disabled: busy || !emailValid, children: busy
                        ? ru
                            ? "Сохраняем…"
                            : "Saving…"
                        : ru
                            ? "Продолжить"
                            : "Continue" })] }) }));
};
